

<div class="search">
    <button class="btn btn-info btn-purchasenewpack" (click)="createNew()">Create {{serviceDisplayName}}</button>
    <div class="search-input-icon">
        <div class="search-input"><i class="flaticon-search"></i></div>
        <input type='text' [placeholder]='"Search " + serviceDisplayName + "s.."' (keyup)='search()' [(ngModel)]="searchText" class="searchtext"/>
    </div>
    <span *ngIf="hasSiteManagement" style="padding-left: 10px; margin-top: 12px; vertical-align: middle; text-align: center;">Show Inactive</span>
	<label *ngIf="hasSiteManagement" class="switch" style="margin-left: 5px; margin-top: 10px; vertical-align: middle; text-align: center;">
	<input
		id="showInactiveServices"
        type="checkbox" class="form-control"
        [(ngModel)]="showInactive"
		(change)="search();">
	<span class="slider round"></span>
    </label>
</div>
<br>

<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
</ngx-spinner>

<ngx-datatable #packageTable
               class='material striped datatable'
               [rows]='displayItems'
               [columnMode]='"force"'
               [headerHeight]='40'
               [footerHeight]='20'
               [scrollbarH]="true"
               [scrollbarV]="true"
               [rowHeight]="40"
               [messages]='{emptyMessage:"No " + serviceDisplayName + "s to display here!"}'
               [reorderable]="true">

    <ngx-datatable-column *ngIf="hasSiteManagement" prop="status" [sortable]="true" [width]="60" [minWidth]="60" [maxWidth]="60">
        <ng-template let-column="column"  ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">Status</span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            <div class="center">
                <div placement="right" container="body" tooltip="Track is not programmed, action is required" *ngIf="row.status === 1" style="background-color:orangered;" class="circle"></div>
                <div placement="right" container="body" tooltip="User can program their own tracks but hasn't, action may be required" *ngIf="row.status === 2" style="background-color:yellow;" class="circle"></div>
                <div placement="right" container="body" tooltip="Track is programmed, no action is required" *ngIf="row.status === 3" style="background-color:green;" class="circle"></div>
            </div>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="name" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Light Show Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.name}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="createdBy" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Created By
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.createdBy}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column *ngIf="hasSiteManagement"  prop="modifiedBy" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Modified By / Date
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.modifiedBy ? row.modifiedBy : 'empty'}} / {{row.dateModified | date:'MM-d-y'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column *ngIf="hasSiteManagement" prop="serviceId" [sortable]="true" [minWidth]="80" [maxWidth]="80">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Service ID
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.serviceId}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column *ngIf="hasSiteManagement" prop="engineName" [sortable]="true" width="100">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Engine Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.engineName}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="startDate" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Start Date
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.startDate | date:'MM-d-y'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="endDate" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                End Date
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.endDate | date:'MM-d-y'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="" [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Track/Video Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.trackName && !row.videoName ? row.trackName : ''}} {{row.videoName}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="" [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Redirect Type
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.redirectType === 1 ? 'Coupon' : row.redirectType === 2 ? 'URL' : row.redirectType === 3 ? 'UPN' : row.redirectType === 4 ? 'Reward' : row.redirectType === 5 ? 'SMS' : row.redirectType === 6 ? 'SC' : 'None'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="title" [sortable]="true" [minWidth]="120" [maxWidth]="120">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Light Show File
            </span>
        </ng-template>
        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template >
             <a *ngIf="row.active && !downloadStates[rowIndex + '-download'] || downloadStates[rowIndex + '-download'] === 0" (click)="checkDownloadLink(row, rowIndex)" download href="#">Download</a>
             <a *ngIf="!row.active" (click)="regenerate(row.id)" download href="#">Regenerate</a>
             <span *ngIf="downloadStates[rowIndex + '-download'] === 1 && downloadStates[rowIndex + '-downloadPercent'] === 0">Preparing download...</span>
             <span *ngIf="downloadStates[rowIndex + '-download'] === 1 && downloadStates[rowIndex + '-downloadPercent'] > 0">{{downloadStates[rowIndex + '-downloadPercent']}}%</span>
             <span *ngIf="downloadStates[rowIndex + '-download'] === 3">Complete</span>
             <span *ngIf="downloadStates[rowIndex + '-download'] === 4">Error</span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column *ngIf="hasSiteManagement" prop="title" [sortable]="true" [minWidth]="120" [maxWidth]="120">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Trigger File
            </span>
        </ng-template>
        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template >
             <a *ngIf="!row.active" (click)="regenerate(row.id)" download href="#">Regenerate</a>
             <a *ngIf="row.active && (!downloadStates[rowIndex + '-download-triggers'] || downloadStates[rowIndex + '-download-triggers'] === 0) && row.triggerFileDownloadUrl" (click)="checkDownloadLink(row, rowIndex, true)" download href="#">Download</a>
             <span *ngIf="downloadStates[rowIndex + '-download-triggers'] === 1 && downloadStates[rowIndex + '-downloadPercent-triggers'] === 0">Preparing download...</span>
             <span *ngIf="downloadStates[rowIndex + '-download-triggers'] === 1 && downloadStates[rowIndex + '-downloadPercent-triggers'] > 0">{{downloadStates[rowIndex + '-downloadPercent-triggers']}}%</span>
             <span *ngIf="downloadStates[rowIndex + '-download-triggers'] === 3">Complete</span>
             <span *ngIf="downloadStates[rowIndex + '-download-triggers'] === 4">Error</span>
             <span *ngIf="row.active && !row.triggerFileDownloadUrl">Unavailable</span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="publicReferenceNumber" [sortable]="true" [minWidth]="150" [maxWidth]="170">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Public Preview Link
            </span>
        </ng-template>
        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template >
             <a *ngIf="row.publicReferenceNumber && !copied[row.publicReferenceNumber]" (click)="copyPublicLink(row.publicReferenceNumber)" href="#">Copy to clipboard</a>
             <a *ngIf="row.publicReferenceNumber && copied[row.publicReferenceNumber]" (click)="copyPublicLink(row.publicReferenceNumber)" href="#">Copied!</a>
             <span *ngIf="!row.publicReferenceNumber" tooltip="To generate a public link, edit this lightshow, then click Update and return to this page.">Unavailable</span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="dateCreated" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Date Created (UTC)
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.dateCreated | date:'MM-d-y'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column *ngIf="hasSiteManagement" prop="active" [sortable]="true" [minWidth]="60" [maxWidth]="60">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Active
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.active}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="actions" [sortable]="false" [minWidth]="180" [maxWidth]="180" >
        <ng-template let-column="column" ngx-datatable-header-template class="actions-row">
            <span></span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            <button tooltip="Edit Light Show" class="btn btn-success btn-icon" (click)="handleEditLightShow(row.id, row.serviceId)"><i class="flaticon-edit-1"></i></button>
            <button  tooltip="Duplicate Light Show" *ngIf="row.active" class="btn btn-info btn-icon" (click)="duplicate(row.id)"><i class="flaticon-app"></i></button>
            <button tooltip="Delete Light Show" *ngIf="row.active" class="btn btn-danger btn-icon" (click)="delete(row.id)"><i class="flaticon-cancel"></i></button>
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>





